export default __webpack_public_path__ + "images/star2.png";